// extracted by mini-css-extract-plugin
export default {"whatsapp_button":"btn-whatsapp_whatsapp_button__40xz7","moverotate":"btn-whatsapp_moverotate__DdP-Z"};